var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"registered-qualified"},_vm._l((_vm.registration_carrer),function(item,index){return _c('div',{key:index},[(item)?[_c('b',[_vm._v(_vm._s(_vm.keys[index]))]),_vm._v(": "+_vm._s(item)+" ")]:_vm._e()],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }